import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Email } from '@compiere-ws/models/apiz-domains';
import { EmailModel } from '@compiere-ws/models/compiere-mail-json';
import { AppConfig } from '@iupics-config/app.config.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private url: string;

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
    this.url = this.config.getBackendResource('email');
  }

  getEmailModels(): Observable<EmailModel[]> {
    return this.http.get<EmailModel[]>(this.url);
  }

  sendEmail(email: Email): Observable<object> {
    return this.http.post(this.url, email);
  }

  getEmailTo<T extends { email: string }>(userId: number): Observable<T> {
    return this.http.get<T>(`${environment.config.backend.ws.url}/mail/to/${userId}`);
  }
}
